define('seApp/controllers/play_template',[

  'app/components/play_template'

], function (
  PlayPageView
) {

  var LOG_LABEL = 'PLAY'

  var _v = {
      view: null,
      config: {
        assets_uri: null
      }
    },
    _fn = {},
    fn = {
      init: function () {
        // ### // grab global vars --------------------------------------------------------

        //_v.config.assets_uri = window.$t.assets_uri;

      },
      render_once: window.once(function (onRenderedCb) {

        var isPrintmode = !!($('#printIndicator').css('display') == 'none')

        _v.view = new PlayPageView({
          isPrintmode: isPrintmode,
          oncomplete: function () {

            onRenderedCb()

          }
        })

      }),
      render: function (onRenderedCb) {
        this.render_once(onRenderedCb)
      }
    }

  return fn

})


;
